import React from 'react'

import Slider, { Range, Handle } from 'rc-slider';
import Tooltip from 'rc-tooltip';
import 'rc-slider/assets/index.css';

const handle = (props, isDreamSpace, max) => {
  const { value, dragging, index, ...restProps } = props;

  const offset = ( value >= 10 ? 2 : 1 )
  const position = value / max * 100 - offset
  const className = isDreamSpace ? 'dreamspace' : '';

  return (
    <div className='rc-tooltip'>
      <div className={`rc-value ${className}`} style={ { left: `${position}%` } }>
        { value }
      </div>
      <Handle value={value} {...restProps} />
    </div>
  );
};

class RepaymentYear extends React.Component {
  onChange = (value) => {
    this.props.onChange(value)
  };

  render() {
    const {
      defaultValue,
      label,
      isDreamSpace,
      max = 30,
      marks = {
        0:  { style: { fontSize: '17px' }, label: 0 },
        5:  { style: { fontSize: '17px' }, label: 5 },
        10: { style: { fontSize: '17px' }, label: 10 },
        15: { style: { fontSize: '17px' }, label: 15 },
        20: { style: { fontSize: '17px' }, label: 20 },
        25: { style: { fontSize: '17px' }, label: 25 },
        30: { style: { fontSize: '17px' }, label: 30 },
      }
    } = this.props;

    const styles = {
      track: {
        backgroundColor: '#10c98f',
      },
      handle: {
        borderColor: '#10c98f',
        width: '16px',
        height: '16px',
        borderWidth: '5px',
      },
      dot: {
        display: 'none',
      },
      mark: {
        fontSize: '17px',
      }
    }

    if (isDreamSpace) {
      styles.track.backgroundColor = '#683DE3'
      styles.handle.borderColor = '#683DE3'
    }

    return(
      <div className='repayment-year'>
        <div className="form-group mb-0">
          <label>{label}</label>
        </div>

        <div className='row no-gutters mb-3'>
          <div className='col-12 col-sm-8 mr-2'>
            <div className='slider-container'>
              <Slider
                min={ 0 }
                step={ 1 }
                marks={ marks }
                max={ max }
                handle={(data) => handle(data, this.props.isDreamSpace, max) }
                onChange={ this.onChange }
                defaultValue={ defaultValue }
                trackStyle={ styles.track }
                handleStyle={ styles.handle }
                dotStyle={ styles.dot }
                markStyle={styles.marks }
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default RepaymentYear;
